import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles/styles.css";
import "./styles/Slider.css";

import Game from "./App";

const root = createRoot(document.getElementById("root"));
root.render(
    <StrictMode>
        <Game />
    </StrictMode>
);
